import React from 'react';
import { Box, Typography, Grid, Link, Container, Button, Divider } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const Footer = () => {
  const theme = useTheme();

  return (
    <Box sx={{
      background: theme.palette.primary.dark,
      color: theme.palette.common.white,
      mt: 8,
      borderTop: `2px solid ${theme.palette.secondary.main}`
    }}>
      <Container maxWidth="xl" sx={{ py: 6 }}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={{ 
              mb: 2,
              fontWeight: 700,
              color: theme.palette.common.white,
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }}>
              <Box component="span" sx={{
                width: 8,
                height: 32,
                bgcolor: theme.palette.secondary.main,
                borderRadius: '4px'
              }} />
              Orglance
            </Typography>
            <Typography variant="body2" sx={{ 
              color: theme.palette.grey[400],
              lineHeight: 1.8,
              pr: 4
            }}>
              Transform your data into actionable insights with AI-powered analytics solutions.
            </Typography>
          </Grid>

          <Grid item xs={6} md={2}>
            <Typography variant="subtitle1" sx={{ 
              mb: 2,
              fontWeight: 600,
              color: theme.palette.common.white
            }}>
              Product
            </Typography>
            {['Features', 'Pricing', 'Documentation', 'Releases'].map((item) => (
              <Link href="#" key={item} sx={{
                display: 'block',
                mb: 1.5,
                color: theme.palette.grey[400],
                textDecoration: 'none',
                position: 'relative',
                transition: 'all 0.2s ease',
                '&:hover': {
                  color: theme.palette.secondary.light,
                  transform: 'translateX(8px)',
                  '&:after': {
                    width: '100%'
                  }
                },
                '&:after': {
                  content: '""',
                  position: 'absolute',
                  bottom: -2,
                  left: 0,
                  width: '0%',
                  height: '2px',
                  background: theme.palette.secondary.light,
                  transition: 'width 0.3s ease'
                }
              }}>
                {item}
              </Link>
            ))}
          </Grid>

          <Grid item xs={6} md={2}>
            <Typography variant="subtitle1" sx={{ 
              mb: 2,
              fontWeight: 600,
              color: theme.palette.common.white
            }}>
              Company
            </Typography>
            {['About', 'Careers', 'Contact', 'Blog'].map((item) => (
              <Link href="#" key={item} sx={{
                display: 'block',
                mb: 1.5,
                color: theme.palette.grey[400],
                textDecoration: 'none',
                position: 'relative',
                transition: 'all 0.2s ease',
                '&:hover': {
                  color: theme.palette.secondary.light,
                  transform: 'translateX(8px)',
                  '&:after': {
                    width: '100%'
                  }
                },
                '&:after': {
                  content: '""',
                  position: 'absolute',
                  bottom: -2,
                  left: 0,
                  width: '0%',
                  height: '2px',
                  background: theme.palette.secondary.light,
                  transition: 'width 0.3s ease'
                }
              }}>
                {item}
              </Link>
            ))}
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" sx={{ 
              mb: 2,
              fontWeight: 600,
              color: theme.palette.common.white
            }}>
              Stay Updated
            </Typography>
            <Box component="form" sx={{ display: 'flex', gap: 1.5 }}>
              <input
                type="email"
                placeholder="Enter your email"
                style={{
                  flex: 1,
                  padding: '12px 16px',
                  borderRadius: '8px',
                  border: `1px solid ${theme.palette.grey[600]}`,
                  background: 'rgba(255, 255, 255, 0.05)',
                  color: theme.palette.common.white,
                  fontSize: '0.875rem',
                  transition: 'all 0.2s ease',
                  '&:focus': {
                    outline: 'none',
                    borderColor: theme.palette.secondary.main,
                    boxShadow: `0 0 0 2px ${theme.palette.secondary.light}`
                  }
                }}
              />
              <Button
                variant="contained"
                sx={{
                  background: `linear-gradient(45deg, ${theme.palette.secondary.main}, ${theme.palette.primary.main})`,
                  color: theme.palette.common.white,
                  borderRadius: '8px',
                  px: 3,
                  textTransform: 'none',
                  fontWeight: 600,
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                  '&:hover': {
                    transform: 'translateY(-2px) scale(1.05)',
                    boxShadow: theme.shadows[6],
                    background: `linear-gradient(45deg, ${theme.palette.secondary.light}, ${theme.palette.primary.light})`
                  }
                }}
              >
                Subscribe
              </Button>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ 
          my: 6, 
          borderColor: theme.palette.grey[700],
          opacity: 0.5 
        }} />

        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 2
        }}>
          <Typography variant="body2" sx={{ 
            color: theme.palette.grey[400],
            order: { xs: 2, md: 1 }
          }}>
            © {new Date().getFullYear()} Orglance. All rights reserved.
          </Typography>
          
          <Box sx={{ 
            display: 'flex', 
            gap: 3, 
            order: { xs: 1, md: 2 },
            mb: { xs: 2, md: 0 }
          }}>
            <Link href="#" sx={{ 
              color: theme.palette.grey[400], 
              '&:hover': { color: theme.palette.secondary.main } 
            }}>
              Privacy Policy
            </Link>
            <Link href="#" sx={{ 
              color: theme.palette.grey[400], 
              '&:hover': { color: theme.palette.secondary.main } 
            }}>
              Terms of Service
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;